import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';
import Circle, { CircleProps } from './circle';
import { IconName } from '../../atoms/icons';
import IconChild from '../../atoms/icons/icon-child';

export interface Props extends CircleProps {
  icon?: IconName;
}

class CircleWithIcon extends React.Component<Props, any> {
  public render() {
    const { className, icon } = this.props;
    return (
      <div className={className}>
        <Circle {...this.props}>
          {icon && <IconChild icon={icon} key={icon} />}
        </Circle>
      </div>
    );
  }
}

const StyledCircleWithIcon = styled(CircleWithIcon)`
  display: block;

  .icon {
    fill: ${props => props.color};
  }
`;

StyledCircleWithIcon.defaultProps = {
  color: colors.blue500,
};

export default StyledCircleWithIcon;
